import { USER_INFO, CUR_ROLE, ROLE_LIST, CUR_TENANT } from '@/config/const';
import { IStorageResourceParams } from '@/utils/interface';
import { CryptoHelper } from '@/utils';
import store from '@/store';
import router from '@/router';
import bigDataLog from '@/utils/bigLogData';
import { getChildModuleNameByPath } from '@/hooks/useMenuClick';
import { getCurrentRoleName } from '@/utils/bigLogData/trackHelper';
const currentTenantDefault = {
  customCode: 'annto',
  id: 291,
  sourceTenantCode: 'T201904230000000014',
  tenantAdminFlag: 0,
  tenantCode: 'annto',
  tenantDomain: 'an-uat.midea.com',
  tenantName: '安得智联',
};
/** 登录后预初始化系统，跳转前完成权限加载 */
export const preInitSystem = async (): Promise<boolean> => {
  try {
    const res = await store.dispatch('initSystem');
    if (res != null && res.data !== undefined) {
      // 系统初始化成功后，记录用户访问次数（childModuleName 与 sendDetailMessage 一致）
      const redirectUrl = router.currentRoute.value.query.redirectUrl;
      const path =
        typeof redirectUrl === 'string' && redirectUrl
          ? decodeURIComponent(redirectUrl).split('?')[0]
          : '';
      bigDataLog.sendMainMessage(getChildModuleNameByPath(path, getCurrentRoleName()));
      return true;
    }
    return false;
  } catch {
    return false;
  }
};

export const storageResource = async (params: IStorageResourceParams) => {
  const { roleCode, roleList, userInfo, currentTenant } = params;
  // 生成 AES 密钥
  const key = await CryptoHelper.generateKey();

  if (roleCode) {
    localStorage.setItem(CUR_ROLE, roleCode);
    store.commit('updateCurRole', roleCode);
  }
  if (Array.isArray(roleList) && roleList.length > 0) {
    localStorage.setItem(ROLE_LIST, JSON.stringify(roleList));
    store.commit('updateRoleList', roleList);
  }
  if (userInfo && Object.keys(userInfo).length > 0) {
    userInfo.currentTenant = currentTenantDefault;
    const encryptedData = await CryptoHelper.encrypt(JSON.stringify(userInfo), key);
    localStorage.setItem(USER_INFO, encryptedData);
    store.commit('updateUserInfo', userInfo);
  }
  if (currentTenant && Object.keys(currentTenant).length > 0) {
    localStorage.setItem(CUR_TENANT, JSON.stringify(currentTenantDefault));
    store.commit('updateCurrenTenant', currentTenant);
  }
};
